"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NEW_ENTRY_WINDOW_DAYS = exports.CHANGELOG_READ_AT_KEY = void 0;
exports.changelogIsUnread = changelogIsUnread;
/**
 * Unread logic for the header changelog icon. An entry is "unread" when it
 * was published after the user's last visit to the changelog page (stored in
 * localStorage), capped so entries older than NEW_ENTRY_WINDOW_DAYS never
 * light up the icon -- a fresh browser shouldn't alert on ancient news.
 */
exports.CHANGELOG_READ_AT_KEY = "ds-changelog-read-at";
exports.NEW_ENTRY_WINDOW_DAYS = 30;
var MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;
function changelogIsUnread(latestPublishedAt, lastReadAt, now) {
    if (!latestPublishedAt) {
        return false;
    }
    var windowStart = now.getTime() - exports.NEW_ENTRY_WINDOW_DAYS * MILLISECONDS_PER_DAY;
    var readAt = lastReadAt ? new Date(lastReadAt).getTime() : 0;
    var baseline = Math.max(readAt, windowStart);
    return new Date(latestPublishedAt).getTime() > baseline;
}
